import React from 'react'
import {
  DialogContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'
import { ErrorBoundary } from 'react-error-boundary'

import { useCustomer, useUpdateCustomer } from './admin-api'

type LLMProviderType = 'chat-gpt' | 'chat-azure' | 'chat-vertex' | null

const AdminSwitchProviderContent = () => {
  const customerQuery = useCustomer()
  const updateCustomerMutation = useUpdateCustomer()

  const { customer } = customerQuery.data
  const currentProvider = customer.llmProvider

  const handleChange = (provider: LLMProviderType) => {
    if (currentProvider !== provider) {
      updateCustomerMutation.mutate({ llmProvider: provider })
    }
  }

  return (
    <DialogContent sx={{ pt: '0px !important' }}>
      <Typography fontWeight="bold" mb={1}>
        LLM Provider Selection
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Toggle between OpenAI GPT, Azure-hosted GPT, or our model’s default LLM Provider.
      </Typography>
      <FormControl>
        <RadioGroup
          value={currentProvider ?? 'default'}
          onChange={(e) =>
            handleChange(e.target.value === 'default' ? null : (e.target.value as LLMProviderType))
          }
        >
          <FormControlLabel
            value="chat-gpt"
            control={<Radio color="secondary" />}
            label="OpenAI GPT"
          />
          <FormControlLabel
            value="chat-azure"
            control={<Radio color="secondary" />}
            label="Azure-hosted GPT"
          />
          <FormControlLabel
            value="chat-vertex"
            control={<Radio color="secondary" />}
            label="Vertex AI"
          />
          <FormControlLabel
            value="default"
            control={<Radio color="secondary" />}
            label="Model default LLM Provider"
          />
        </RadioGroup>
      </FormControl>
    </DialogContent>
  )
}

export const AdminSwitchProvider = () => {
  return (
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
      <React.Suspense fallback={<div>Loading...</div>}>
        <AdminSwitchProviderContent />
      </React.Suspense>
    </ErrorBoundary>
  )
}
